export const colors = {
    pColor: '#7000e3',
    pDark: '#50119e',
    pLight: '#7d18ff',
    sColor: '#00ffff',
    textColor: '#727272',
    titleColor: '#353535'
};

export const borders = {
    bRadius: '10px',
    bRadiusBig: '50px',
}

export const anims = {
    transition: 'transition: 1s ease-in-out'
}